/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2021, 2025
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import { createSlice } from '@reduxjs/toolkit';

import { ApiStatus } from '../../../../ts';
import { getAIModelData } from './actions';

// Initial State
const initialState = {
  loading: ApiStatus.IDLE, // idle, pending, fulfilled, error
  models: [],
  default_model: '',
  error: null
};

// Slice + Reducer
const slice = createSlice({
  name: 'aiModels',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getAIModelData.pending, (state, _) => {
        state.loading = ApiStatus.LOADING;
        state.error = null;
      })
      .addCase(getAIModelData.fulfilled, (state, action) => {
        state.loading = ApiStatus.SUCCEEDED;
        state.error = null;
        state.models = action.payload.models;
        state.default_model = action.payload.default_model;
      })
      .addCase(getAIModelData.rejected, (state, action) => {
        state.loading = ApiStatus.ERROR;
        state.error = action.error;
      });
  }
});

export default slice.reducer;
